import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart, ArrowLeft, Loader2 } from 'lucide-react';
import { legalApi } from '../../lib/api';

export default function LegalTextPage() {
    const location = useLocation();
    const path = location.pathname;
    const meta = path.includes('nutzungsbedingungen')
        ? { type: 'terms_of_service', title: 'Nutzungsbedingungen' }
        : path.includes('impressum')
        ? { type: 'imprint', title: 'Impressum' }
        : { type: 'privacy_policy', title: 'Datenschutzhinweise' };
    const textType = meta.type;
    const title = meta.title;

    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadContent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textType]);

    const loadContent = async () => {
        try {
            const res = await legalApi.get(textType);
            setContent(res.data.html_content || '');
        } catch (error) {
            console.error('Fehler beim Laden:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-secondary">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
                    <div className="flex items-center justify-between">
                        <Link to="/seminare" className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm" data-testid="back-link">
                            <ArrowLeft className="h-4 w-4" />
                            Zurück
                        </Link>
                        <div className="flex items-center gap-2">
                            <Heart className="h-5 w-5 text-primary" />
                            <span className="text-sm font-semibold text-white">BGPR</span>
                        </div>
                    </div>
                </div>
            </header>

            <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6" data-testid="legal-title">{title}</h1>
                {loading ? (
                    <div className="flex justify-center py-16">
                        <Loader2 className="h-8 w-8 animate-spin text-primary" />
                    </div>
                ) : content ? (
                    <div
                        className="legal-html bg-white p-6 sm:p-8 rounded-2xl border border-gray-100 shadow-sm"
                        dangerouslySetInnerHTML={{ __html: content }}
                        data-testid="legal-content"
                    />
                ) : (
                    <div className="text-center py-16 bg-white rounded-2xl border border-gray-100">
                        <p className="text-gray-500">Dieser Text wurde noch nicht hinterlegt.</p>
                    </div>
                )}
            </main>

            <footer className="bg-secondary mt-16 py-8">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <Heart className="h-4 w-4 text-primary" />
                        <span className="text-sm font-semibold text-white">BGPR</span>
                    </div>
                    <p className="text-xs text-gray-500">
                        Berliner Gesellschaft für Prävention und Rehabilitation von Herz-Kreislauferkrankungen e.V.
                    </p>
                </div>
            </footer>
        </div>
    );
}
